/**
 * Light/dark theme toggle with localStorage persistence.
 * Initial `data-theme` on <html> is set by an inline script in snippets/head.liquid
 * (before CSS load) to avoid FOUT.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'off-theme';
  const root = document.documentElement;

  function getStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function getSystem() {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function getTheme() {
    return root.getAttribute('data-theme') || getStored() || getSystem();
  }

  function setTheme(theme) {
    const value = theme === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-theme', value);
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
    document.dispatchEvent(new CustomEvent('off:theme-change', { detail: { theme: value } }));
  }

  function toggleTheme() {
    setTheme(getTheme() === 'dark' ? 'light' : 'dark');
  }

  function bindButtons() {
    document.querySelectorAll('[data-set-theme]').forEach((btn) => {
      if (btn.__offThemeBound) return;
      btn.addEventListener('click', () => setTheme(btn.getAttribute('data-set-theme')));
      btn.__offThemeBound = true;
    });
    document.querySelectorAll('[data-toggle-theme]').forEach((btn) => {
      if (btn.__offThemeBound) return;
      btn.addEventListener('click', toggleTheme);
      btn.__offThemeBound = true;
    });
  }

  function updateButtonStates() {
    const current = getTheme();
    document.querySelectorAll('[data-set-theme]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-set-theme') === current ? 'true' : 'false');
    });
  }

  function init() {
    bindButtons();
    updateButtonStates();
  }

  // Binding non visual-critical: differito a idle (convenzione MadeInEvolve).
  var idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(init); }, { once: true });
  } else {
    idle(init);
  }

  document.addEventListener('off:theme-change', updateButtonStates);

  // Theme editor: il re-render di una section crea bottoni nuovi non bindati (evento emesso solo nel customizer).
  document.addEventListener('shopify:section:load', init);

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (!getStored()) setTheme(e.matches ? 'dark' : 'light');
  });

  window.OffPorter = window.OffPorter || {};
  window.OffPorter.theme = {
    get: getTheme,
    set: setTheme,
    toggle: toggleTheme,
    rebind: () => { bindButtons(); updateButtonStates(); },
  };
})();
